"use client";

import { useEnrollmentRounds } from "@/themes/default/templates/section/enrollment/useEnrollmentRounds";

const GOLD = "#C9A24B";

/**
 * um1sf enrollment banner — editorial "admission band": full-bleed primary
 * fill, gold rule on top, serif program name, square white CTA and an
 * underlined text link (same idiom as um1sf CallToActionSection).
 */
export function EnrollmentBanner({
  section,
  currentLanguage = "mm",
}: {
  section: any;
  currentLanguage?: "en" | "mm";
}) {
  const d = useEnrollmentRounds(section, currentLanguage);
  if (!d) return null;

  return (
    <section
      className="w-full"
      lang={d.lang === "mm" ? "my" : "en"}
      style={{ backgroundColor: "var(--color-primary)", color: "var(--color-primary-foreground)" }}
    >
      <div className="h-1 w-full" style={{ backgroundColor: GOLD, opacity: 0.85 }} />
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        {d.rounds.map((r, i) => (
          <div
            key={r.id}
            className={`flex flex-col gap-5 py-7 md:flex-row md:items-center md:gap-10 ${
              i > 0 ? "border-t border-white/20" : ""
            }`}
          >
            <div className="min-w-0 flex-1">
              <p className="flex items-center gap-3 text-[0.7rem] font-semibold uppercase tracking-[0.12em] text-white/80">
                <span className="h-px w-8" style={{ backgroundColor: GOLD }} aria-hidden="true" />
                {d.title}
              </p>
              <h2
                className="mt-2 text-xl font-bold md:text-2xl"
                style={{ fontFamily: "var(--font-serif)", lineHeight: d.lang === "mm" ? 1.8 : 1.3 }}
              >
                {r.label}
              </h2>
              {r.window && (
                <p className="mt-1 text-sm text-white/80">
                  {d.t.windowPrefix} {r.window}
                </p>
              )}
            </div>
            <div className="flex shrink-0 flex-wrap items-center gap-6">
              {r.listHref && (
                <a
                  href={r.listHref}
                  className="inline-flex items-center gap-1 border-b border-current pb-0.5 text-sm font-medium transition-opacity hover:opacity-80"
                >
                  {d.t.list} <span aria-hidden="true">→</span>
                </a>
              )}
              <a
                href={r.enrollHref}
                className="inline-flex items-center gap-2 bg-white px-6 py-3 text-sm font-semibold tracking-wide text-primary transition-colors hover:bg-white/90"
              >
                {d.t.enroll} <span aria-hidden="true">→</span>
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
